import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Typography } from "@mui/material";
import { PersonAddAltOutlined } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";
import Loader from "../common/loader";

export default function LobbyInviteMobileRow({
    pendingInvite = null,
    avatarSrc = null,
    action = null,
}) {
    if (pendingInvite) {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: "0.55rem",
                    minHeight: "3.85rem",
                    padding: "0.55rem 0.75rem",
                    boxSizing: "border-box",
                    borderRadius: "12px",
                    border: `1px dashed ${alpha(colors.primary.main, 0.28)}`,
                    background: alpha(colors.background.card, 0.55),
                }}
            >
                <Loader size={22} />
                <Avatar
                    src={avatarSrc || undefined}
                    sx={{
                        width: "2.55rem",
                        height: "2.55rem",
                        flexShrink: 0,
                    }}
                />
                <Box
                    sx={{
                        minWidth: 0,
                        flex: "1 1 auto",
                        textAlign: "left",
                    }}
                >
                    <Typography
                        sx={{
                            color: colors.text.secondary,
                            fontSize: "0.68rem",
                            fontWeight: 700,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            textAlign: "left",
                        }}
                    >
                        Inviting
                    </Typography>
                    <Typography
                        sx={{
                            color: colors.text.primary,
                            fontSize: "0.9rem",
                            fontWeight: 700,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            textAlign: "left",
                        }}
                    >
                        {pendingInvite.nickname}
                    </Typography>
                </Box>
                {action}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flexWrap: "nowrap",
                gap: "0.7rem",
                minHeight: "3.85rem",
                padding: "0.55rem 0.75rem",
                boxSizing: "border-box",
                borderRadius: "12px",
                cursor: "pointer",
                border: "1px solid rgba(255,255,255,.055)",
                background: `
                    linear-gradient(
                        90deg,
                        rgba(255,255,255,.014),
                        rgba(255,255,255,.006)
                    )
                `,
                transition: "border-color 160ms ease, background 160ms ease",
                "&:hover": {
                    background: "rgba(232,163,61,.035)",
                    borderColor: "rgba(232,163,61,.16)",
                },
            }}
        >
            <PersonAddAltOutlined
                sx={{
                    color: colors.text.primary,
                    fontSize: "1.3rem",
                    flexShrink: 0,
                    filter: `drop-shadow(0 2px 4px ${alpha(colors.background.dark, 0.45)})`,
                }}
            />

            <Typography
                sx={{
                    flex: 1,
                    minWidth: 0,
                    color: colors.text.primary,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    letterSpacing: "0.07em",
                    textTransform: "uppercase",
                    textAlign: "left",
                    textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                Empty Slot
            </Typography>
        </Box>
    );
}

LobbyInviteMobileRow.propTypes = {
    pendingInvite: PropTypes.object,
    avatarSrc: PropTypes.string,
    action: PropTypes.node,
};
